import Axios from 'axios';

export default {
  create(digitalContract) {
    return Axios.post('/admin/parcelamento/institution-digital-contracts', digitalContract);
  },

  disable(digitalContractId) {
    return Axios.put(`/admin/parcelamento/institution-digital-contracts/${digitalContractId}/disable`);
  },

  getDigitalContracts(institutionId) {
    return Axios.get('/admin/parcelamento/institution-digital-contracts', {
      params: { institution_id: institutionId },
    }).then(({ data }) => data);
  },
};
